import InfiniteScrollList from "../../../../../common/infinite-scroll-list";
import ConfigService from "../../../../../../services/ConfigService";
import JWTClient from "../../../../../../services/JWTClient";
import ContactItem from "../contact-item";

export default class ContactsInfiniteScrollList extends InfiniteScrollList {
    emptyStateMessage = 'chat.list.empty';
    domain = ConfigService.organigrammaServerUrl();
    profileId = ConfigService.userProfile().id;

    constructor(props) {
        super(props);
        this.state.page = 1;
    }

    static defaultProps = {
        onSelect: () => {},
        selectedContacts: {}
    };

    componentDidMount() {
        this.getNext();
    }

    renderItem = (item) => (item.id === this.profileId) ? null :(
        <ContactItem item={item}
                     onToggle={this.toggle}
                     selected={this.props.selectedContacts.hasOwnProperty(item.id)}
        />
    );

    getNextRequest = () => {
        return JWTClient.fetch(this.domain + '/users?sortBy=username&direction=asc&limit=30&page=' + this.state.page)
            .then(res => {
                this.setState({page: (this.state.page || 1) + 1});
                return res;
            });
    };

    toggle = (contactId) => {
        const map = this.props.selectedContacts;
        if (map.hasOwnProperty(contactId)) {
            delete map[contactId];
        } else {
            map[contactId] = this.state.list.find(c => c.id === contactId);
        }
        this.props.onSelect(map);
    };
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/chat/contacts-infinite-scroll-list/index.js